module.exports = __webpack_public_path__ + "img/assessment.eecea70e.svg";